module.exports = __webpack_public_path__ + "static/media/kuriko.e26b8a44.png";